export default (function () {
  return ![typeof window, typeof document].includes("undefined") || (console.warn("⚠️[Warning]: current runtime environment is not browser please parse URL to this function"), !1);
});